module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Call-381f0d16c052505ab5c00013f38836ac.svg";